import { InputAdornment, Stack } from "@mui/material";
import GeneralUtilityService from "services/GeneralUtilityService";
import VettedProfileRequirements from "./VettedProfileRequirements";
import NonVettedProfileRequirements from "./NonVettedProfileRequirements";

export const  CandidateVisibilityAdornment = ({ fieldKey }) => {

    const { vetted, nonVetted } = GeneralUtilityService.getFieldVettingLabel(fieldKey);
    
    return (
        <InputAdornment position="start">
            <Stack direction="row" gap={.5}>
                {vetted && <VettedProfileRequirements />}
                {nonVetted && <NonVettedProfileRequirements />}
            </Stack>
        </InputAdornment>
    )
};

export default CandidateVisibilityAdornment;